import { useMemo } from 'react';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useFilterConfig } from './useFilterConfig';
export function useAppliedFilters() {
  const params = useSearchParams();
  const filterConfig = useFilterConfig();
  return useMemo(() => {
    const appliedFilters = [];
    for (const filter of Object.values(filterConfig)) {
      if (!filter) continue;
      const paramValues = params.getList(filter.field);
      if (paramValues.length === 0) continue;
      appliedFilters.push(Object.assign({}, filter, {
        values: paramValues
      }));
    }
    return appliedFilters;
  }, [filterConfig, params]);
}